export default __webpack_public_path__ + "static/media/4Loop.cb40407f.mp4";